import Vue from "vue";
import axios from "axios";
import router from "@/router/index";
import i18n from "@/i18n";
import store from "@/store";
import App from "@/App.vue";
// import VueAnalytics from "vue-analytics";
import moment from "moment";

import "@/filters/formatDate";
import "@/filters/formatCurrencyEuro";
import "@/plugings/font-awesome";
import { mapGetters } from "vuex";
import Requests from "./constants/Requests";

Vue.config.productionTip = false;

// Vue.use(VueAnalytics, {
//   id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID,
//   router
// });

Vue.use({
  install(Vue) {
    const $axiosInstance = axios.create({
      baseURL: Requests.baseUrl
    });
    $axiosInstance.interceptors.response.use(
      response => response,
      error => {
        if (error.response?.status === 401) {
          // if you ever get an unauthorized, logout the user
          store.dispatch("user/logout").then(() => {
            router.push({ name: "confirmCell" });
          });
        }
        return Promise.reject(error);
      }
    );

    $axiosInstance.interceptors.request.use(
      config => {
        Requests.headers.map(customHeader => {
          config.headers[customHeader.key] = customHeader.value;
          config.headers[customHeader.key] = customHeader.value;
          config.headers[customHeader.key] = customHeader.value;
        });

        if (store.getters["user/loggedIn"]) {
          config.headers["Authorization"] =
            "Bearer " + store.getters["user/accessToken"];
        }
        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    Vue.prototype.$http = $axiosInstance;
  }
});

Vue.mixin({
  data() {
    return {
      loading: false,
      result: ''

    };
  },

  computed: {
    ...mapGetters("user", {
      loggedIn: "loggedIn",
      user: "profile",
      registrationState: "registrationState"
    }),
    ...mapGetters("app", {
      topMenu: "topMenu"
    })
  },
  methods: {
    formatDate: (time, newFormat, format = "YYYY-MM-DD HH:mm:ss") =>
      moment
        .utc(time, format)
        .local()
        .format(newFormat)
  }
});

const app = new Vue({
  render: h => h(App),
  store,
  i18n,
  router
});
store.$app = app;
app.$mount("#app");
